$(document).ready(function () {

    // .p-products-details クラスが存在しない場合は、以降のコードを実行しない
    if (!$('.p-products-details').length) {
      return;
    }

  // セクションIDを取得
  var sections = ['#type01', '#type02', '#type03', '#type04', '#type05'];

  // 現在の位置に基づいてactiveクラスを設定する関数
  function setActiveClass() {
    var currentPosition = $(window).scrollTop();
    var foundActive = false;

    sections.forEach(function (section, index) {
      var target = $(section);
      var targetOffset = target.offset();

      if (targetOffset && (targetOffset.top - 150 <= currentPosition && targetOffset.top + target.outerHeight() - 100 > currentPosition)) {
        foundActive = true;
        $('.p-products-details__list').removeClass('active');
        $('.p-products-details__list').eq(index).addClass('active');
      }
    });

    if (!foundActive && currentPosition < $(sections[1]).offset().top - 100) {
      $('.p-products-details__list').removeClass('active');
      $('.p-products-details__list').eq(0).addClass('active');
    }
  }

  // 初期状態で現在の位置に基づいてactiveクラスを設定
  setActiveClass();

  // スクロール時のイベントリスナーを設定
  var debounce;
  $(window).on('scroll', function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      setActiveClass();
    }, 100);
  });

  // クリック時のイベントリスナーを設定
  $('.p-products-details__list a').on('click', function (event) {
    event.preventDefault();
    var target = $($(this).attr('href'));
    var clickedListItem = $(this).closest('.p-products-details__list');

    if (target.length) {
      // 対象のリストアイテムにアクティブクラスを追加
      $('.p-products-details__list').removeClass('active');
      clickedListItem.addClass('active');

      $('html, body').animate({
        scrollTop: target.offset().top - 125
      }, 1);
    }
  });
});
